/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Trigger_Created_By_ColleagueInputs */



/**
* | output |
* | --- |
* | "Set up by a colleague" |
*
* @param {Agent_Trigger_Created_By_ColleagueInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_trigger_created_by_colleague = /** @type {((inputs?: Agent_Trigger_Created_By_ColleagueInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Trigger_Created_By_ColleagueInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Von einer Kollegin oder einem Kollegen eingerichtet")
	return /** @type {LocalizedString} */ ("Set up by a colleague")
});